module.exports = __webpack_public_path__ + "img/logo_en.98003a13.svg";